<template>
     <v-dialog
      v-model="dialog"
      max-width="500"
      persistent
    >
       <v-card>
        <v-toolbar flat dense cad color="info" dark>
				<v-toolbar-title class="subheading text-xs-center">Confirm Sign Off</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>

        <v-card-text class="py-5">
            Are you sure you wish to sign off on this Performance Review?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
					<v-btn flat @click="onCancelClicked">Cancel</v-btn>
					<v-btn color="primary" flat @click="onSignOffClicked">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        dialog: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            
        }
    },
    methods: {
        onSignOffClicked() {
            this.$emit('onSignOff');
        },
        onCancelClicked() {
            this.$emit('onCancel');
        }
    }
}
</script>